import classnames from 'classnames';

import {AsyncImage} from 'components/atoms/Media/AsyncImage';

import 'components/organisms/Map/ThirdPartyMapBlock/style.scss';
import {ImageSizes} from 'components/organisms/Shell/image-size-enum';

import * as React from 'react';
import {getFormattedMessage} from 'features/services/utils/language-helper';
import {AcceptThirdPartModal} from "components/modals/General/AcceptThirdPartyModal";

interface Props {
    renderOnAccept?: React.ReactNode;
    narrow?: boolean;
}

export const ThirdPartyMapBlock: React.FunctionComponent<Props> = ({renderOnAccept, narrow}) => {
    const blockClasses = classnames('third-party-map-block', {
        'third-party-map-block--narrow': narrow,
    });

    return (
        <div className={blockClasses}>
            <AsyncImage
                src={'/static/images/cookie-map.jpg'}
                fullHeight={!narrow}
                quality={ImageSizes.SIZE_1200}
                alt={getFormattedMessage('jm.components.CookieSettingsModal.thirdPartyCookiesDescription')}
            />

            <div className="third-party-map-block__content">
                <AcceptThirdPartModal renderOnAccept={renderOnAccept} />
            </div>
        </div>
    )
};
